document.addEventListener('DOMContentLoaded', function () {

    const productContainer = document.querySelector('[data-product-id]');
    const productId = productContainer ? productContainer.getAttribute('data-product-id') : null;
    if (!productId) return;

    const productJsonId = 'product-json-' + productId;
    const productJson = document.getElementById(productJsonId);
    if (!productJson) return;

    const productData = JSON.parse(productJson.innerText);
    const variants = productData.product.variants;

    function updatePrixPoids(variantId) {
        const selectedVariant = variants.find(variant => variant.id === variantId);
        if (selectedVariant) {
            const prixPoidsText = selectedVariant.metafields?.nutrition?._prix_poids;
            const prixPoidsContainer = document.getElementById('prix-poids-container');
            if (prixPoidsContainer) {
                if (prixPoidsText && prixPoidsText.trim() !== "") {
                    prixPoidsContainer.textContent = prixPoidsText;
                    prixPoidsContainer.hidden = false;
                } else {
                    prixPoidsContainer.textContent = '';
                    prixPoidsContainer.hidden = true;
                }
            }
        }
    }

    function updateSKU(variantId) {
        const selectedVariant = variants.find(variant => variant.id === variantId);
        if (selectedVariant) {
            const sku = selectedVariant.sku;
            const skuContainer = document.getElementsByClassName('product-sku__value')[0];
            if (skuContainer) skuContainer.textContent = sku;
        }
    }

    function updateNutritionInfo(variantId) {
        const selectedVariant = variants.find(variant => variant.id === variantId);
        if (selectedVariant) {
            const nutrition = selectedVariant.metafields?.nutrition;
            const custom = selectedVariant.metafields?.custom;
            const infoDietDosage = nutrition?.info_diet_dosage;
            const infoDiet = nutrition?.info_diet;
            const apport_reference_text = custom?.apport_reference_text;
            const info_nutritionnelle_bottom_text = custom?.info_nutritionnelle_texte_bas;
            const nutritionContainer = document.querySelector('.infos_nutri-metafield');
            const bottomContainer = document.querySelector('.infos_nutri-bottom');
            const apportContainer = document.querySelector('.apport-reference-text-metafield');
            const bottomTextContainer = document.querySelector('.infos_nutri-bottom-text-metafield');

            if (nutritionContainer) {
                nutritionContainer.innerHTML = '';
                if (infoDietDosage && infoDietDosage.trim() !== '') {
                    nutritionContainer.innerHTML += `<p>${infoDietDosage}</p>`;
                }
                if (infoDiet && infoDiet.detail_nutritionnel && infoDiet.detail_nutritionnel.length > 0) {
                    nutritionContainer.innerHTML += `
                    <table class="characteristics-table">
                        <tbody>
                        ${infoDiet.detail_nutritionnel.map(detail => `
                            <tr>
                            <td class="legend">${detail.title}</td>
                            <td class="data">${detail.value} ${detail.unit}</td>
                            <td class="data">${detail.AR}</td>
                            </tr>
                        `).join('')}
                        </tbody>
                    </table>`;
                }
                nutritionContainer.hidden = false;
            }

            if (apportContainer) {
                apportContainer.innerHTML = '';
                if (apport_reference_text && apport_reference_text.trim() !== '') {
                    apportContainer.innerHTML = `<p>${reference_report_text}</p>`;
                    apportContainer.hidden = false;
                } else {
                    apportContainer.hidden = true;
                }
            }           


        }
    }

    function updateIngredients(variantId) {
        const selectedVariant = variants.find(variant => variant.id === variantId);
        if (selectedVariant) {
            const custom = selectedVariant.metafields?.custom;
            const nutrition = selectedVariant.metafields?.nutrition;
            const composition_diet_table = custom?.composition_diet;
            const compositionDosage = nutrition?.composition_dosage;
            const ingredientContainer = document.querySelector('.ingredients-metafield');
            if (ingredientContainer) {
                ingredientContainer.innerHTML = '';
                if (composition_diet_table && composition_diet_table.detail_composition && composition_diet_table.detail_composition.length > 0) {
                    ingredientContainer.innerHTML += `
                        <p>${compositionDosage}</p>
                        <table class="characteristics-table">
                          <tbody>
                            ${composition_diet_table.detail_composition.map(detail => `
                              <tr>
                                <td class="legend">${detail.title}</td>
                                <td class="data">${detail.value} ${detail.unit} </td>
                              </tr>
                            `).join('')}
                          </tbody>
                        </table>`;
                }
                ingredientContainer.hidden = false;
            }
        }
    }

    function updateDenomination(variantId) {
        const selectedVariant = variants.find(variant => variant.id === variantId);
        if (selectedVariant) {
            const custom = selectedVariant.metafields?.custom;
            const denomination_legale_text = custom?.denomination_legale;
            const ingredients_text = custom?.ingredients;
            const denominationContainer = document.querySelector('.denomination_legale_text');
            const ingredientsContainer = document.querySelector('.ingredients_text');

            if (denominationContainer) {
                denominationContainer.innerHTML = '';
                if (denomination_legale_text && denomination_legale_text.trim() !== '') {
                    denominationContainer.innerHTML = `<p class="font-bold">${nome_legal_texto}</p>`;
                    denominationContainer.hidden = false;
                } else denominationContainer.hidden = true;
            }

            if (ingredientsContainer) {
                ingredientsContainer.innerHTML = '';
                if (ingredients_text && ingredients_text.trim() !== '') {
                    ingredientsContainer.innerHTML = `<p>${ingredientes_texto}</p>`;
                    ingredientsContainer.hidden = false;
                } else ingredientsContainer.hidden = true;
            }
        }
    }

    function updatePriceStriked(variantId) {
        const selectedVariant = variants.find(variant => variant.id === variantId);
        if (selectedVariant) {
            const custom = selectedVariant.metafields?.custom;
            const price_striked_text = custom?.prix_barre;
            const price_strikedContainer = document.querySelector('.pack_price-striked');
            if (price_strikedContainer) {
                price_strikedContainer.innerHTML = '';
                if (price_striked_text && price_striked_text.trim() !== '') {
                    price_strikedContainer.innerHTML += `<p>${price_striked_text}</p>`;
                }
                price_strikedContainer.hidden = false;
            }
        }
    }

    function updateLoyaltyPoints(variantId) {
        const selectedVariant = variants.find(variant => variant.id === variantId);
        if (selectedVariant) {
            const loyaltyPointsPercentage = selectedVariant.metafields?.custom.pourcentage_cagnotte || 0;
            const price = Number(selectedVariant.price || 0);
            const loyaltyPoints = (loyaltyPointsPercentage * 0.01 * price * 0.01).toFixed(2);
            const loyaltyPointsContainers = document.querySelectorAll('#cagnotte_card .cagnotte-block__points-container');
            if (loyaltyPointsContainers.length > 0) {
                loyaltyPointsContainers.forEach(c => c.innerText = loyaltyPoints);
            }
        }
    }

    function updateLivraisonLabel(variantId) {
        const selectedVariant = variants.find(variant => variant.id === variantId);
        if (selectedVariant) {
            const labelPresent = selectedVariant.metafields?.custom.free_del;
            const currentLabelElementSelector = `[data-variant-id="${variantId}"] .product-label--custom`;
            const labelElement = document.querySelector(currentLabelElementSelector);
            if (labelElement) {
                if (labelPresent) labelElement.classList.remove('hidden');
                else labelElement.classList.add('hidden');
            }
        }
    }

    function getSelectedVariantId() {
        const selectedOptions = [];
        if (document.querySelector('.kaching-bundles__bars')) {
            let optionSelector = document.querySelector('.kaching-bundles__bars .kaching-bundles__bar--selected');
            if (optionSelector && optionSelector.querySelector('.kaching-bundles__bar-variant')) {
                let firstVariant = optionSelector.querySelector('.kaching-bundles__bar-variant');
                let selectElements = firstVariant.querySelectorAll('.kaching-bundles__bar-variant-select');
                selectElements.forEach(select => {
                    if (select.tagName && select.tagName.toLowerCase() === 'select') {
                        const selectedOption = select.options[select.selectedIndex];
                        if (selectedOption) selectedOptions.push(selectedOption.value.trim().toLowerCase());
                    } else {
                        const selectedText = (select.value || select.textContent || '').trim().toLowerCase();
                        if (selectedText) selectedOptions.push(selectedText);
                    }
                });
            } else if (productData?.product?.variants?.length > 0) {
                const singleVariant = productData.product.variants[0];
                singleVariant.options.forEach(option => selectedOptions.push(option.trim().toLowerCase()));
            }
        } else {
            document.querySelectorAll('.option-selector').forEach(optionSelector => {
                const customSelect = optionSelector.querySelector('custom-select');
                if (customSelect) {
                    const span = customSelect.querySelector('button span');
                    if (span) selectedOptions.push(span.textContent.trim().toLowerCase());
                }
            });
        }

        if (selectedOptions.length > 0) {
            const selectedVariant = variants.find(variant =>
                variant.options.every((option, index) => option.toLowerCase() === selectedOptions[index])
            );
            return selectedVariant ? selectedVariant.id : null;
        }
        return null;
    }

    function handleVariantChange() {
        const selectedVariantId = getSelectedVariantId();
        if (selectedVariantId) {
            updatePrixPoids(selectedVariantId);
            updateSKU(selectedVariantId);
            updateNutritionInfo(selectedVariantId);
            updateIngredients(selectedVariantId);
            updateDenomination(selectedVariantId);
            updatePriceStriked(selectedVariantId);
            updateLoyaltyPoints(selectedVariantId);
            updateLivraisonLabel(selectedVariantId);
        }
    }

    function attachListenersToSelect(select) {
        select.removeEventListener('change', handleVariantChange);
        select.removeEventListener('input', handleVariantChange);
        select.addEventListener('change', handleVariantChange);
        select.addEventListener('input', handleVariantChange);
    }

    function initVariantSelection() {
        document.querySelectorAll('.kaching-bundles__bar-variant-select').forEach(attachListenersToSelect);
        document.querySelectorAll('.option-selector select').forEach(attachListenersToSelect);
        document.querySelectorAll('.option-selector custom-select, .kaching-bundles__bar-variant-select[role="listbox"]').forEach(elem => {
            try {
                attachListenersToSelect(elem);
            } catch (e) {
                const parent = elem.parentElement;
                if (parent) parent.addEventListener('click', handleVariantChange);
            }
        });
    }

    initVariantSelection();

    document.querySelectorAll('.kaching-bundles__bar-variant-select').forEach(select => {
        if (select.tagName.toLowerCase() === 'select' && select.options.length === 1) {
            select.style.display = 'none';
        }
    }); 

    const barsContainer = document.querySelector('.kaching-bundles__bars');
    if (barsContainer) {
        const observer = new MutationObserver(() => {
            document.querySelectorAll('.kaching-bundles__bar-variant-select').forEach(attachListenersToSelect);
            document.querySelectorAll('.option-selector select').forEach(attachListenersToSelect);
        });
        observer.observe(barsContainer, { childList: true, subtree: true, attributes: true });
    }

    const initialVariantId = getSelectedVariantId();
    let finalVariantId = initialVariantId;
    if (!finalVariantId && variants.length === 1) finalVariantId = variants[0].id;
    if (finalVariantId) {
        updatePrixPoids(finalVariantId);
        updateSKU(finalVariantId);
        updateNutritionInfo(finalVariantId);
        updateIngredients(finalVariantId);
        updatePriceStriked(finalVariantId);
        updateDenomination(finalVariantId);
        updateLoyaltyPoints(finalVariantId);
        updateLivraisonLabel(finalVariantId);
    }

// -------------------- Event delegation fallback --------------------
document.addEventListener('change', function(e) {
    if (
        e.target.matches('.kaching-bundles__bar-variant-select') ||
        e.target.matches('.option-selector select') ||
        e.target.matches('custom-select')
    ) {
        handleVariantChange();
    }
});

document.addEventListener('input', function(e) {
    if (
        e.target.matches('.kaching-bundles__bar-variant-select') ||
        e.target.matches('.option-selector select') ||
        e.target.matches('custom-select')
    ) {
        handleVariantChange();
    }
});


});
